export * from './register-surfboard-terminal.dto'
export * from './register-surfboard-online-terminal.dto'
export * from './register-surfboard-terminal-response.dto'